<template>
	<div
		v-if="title || (contactpersons && contactpersons.length)"
		:id="$vnode.key"
		class="c-block-list-contact-person-custom"
	>
		<LongReadTarget
			v-if="title && includeInToc"
			:container-id="$vnode.key"
			:title="title"
		/>

		<BaseH2 v-if="title" tag="h2" class="mb-xl" v-text="title" />

		<div
			v-if="contactpersons && contactpersons.length"
			class="flex flex-col gap-lg"
		>
			<div
				v-for="person in contactpersons"
				:key="person.id"
				class="
					u-color-theme-transition
					flex flex-col
					>=605:flex-row
					items-center
					gap-y-xl
					bg-secondary
					px-3xl
					pt-xl
					pb-2xl
				"
			>
				<div
					class="
						w-full
						>=605:w-4/12col
						flex-shrink flex-grow-0
						order-1
					"
				>
					<p
						v-if="person.title"
						class="
							font-darker-grotesque
							text-label-card
							font-semibold
							mb-2xs
						"
						v-text="person.title"
					></p>
					<BaseH4 v-if="person.name" tag="h3" v-text="person.name" />

					<div
						v-if="person.email || person.phone || person.mobile"
						class="flex flex-col gap-2xs mt-lg"
					>
						<span
							v-if="person.phone"
							class="inline-flex items-center"
						>
							<span class="inline-flex justify-center w-16 mr-md">
								<SvgIconPhone class="w-14" />
							</span>
							<a
								:href="`tel:${person.phone}`"
								class="u-link"
								target="_blank"
								v-text="person.phone"
							></a>
						</span>
						<span
							v-if="person.mobile"
							class="inline-flex items-center"
						>
							<span class="inline-flex justify-center w-16 mr-md">
								<SvgIconMobile class="w-12" />
							</span>
							<a
								:href="`tel:${person.mobile}`"
								class="u-link"
								target="_blank"
								v-text="person.mobile"
							></a>
						</span>
						<span
							v-if="person.email"
							class="inline-flex items-center"
						>
							<span class="inline-flex justify-center w-16 mr-md">
								<SvgIconEmail class="w-14" />
							</span>
							<a
								:href="`mailto:${person.email}`"
								class="u-link"
								target="_blank"
								v-text="person.email"
							></a>
						</span>
					</div>

					<NuxtLinkExt
						v-if="person.bookingLink && person.bookingLink[0]"
						:to="person.bookingLink[0].url"
						:target="person.bookingLink[0].target"
					>
						<BaseButton
							tag="div"
							class="mt-xl max-w-fit"
							v-text="person.bookingLink[0].name"
						/>
					</NuxtLinkExt>
				</div>

				<UmbracoImageExt
					v-if="person.image"
					:widths="[220, 260]"
					:alt="person.image.altText"
					:source-url="person.image.cropUrl"
					:source-width="person.image.width"
					:source-height="person.image.height"
					:aspect-ratio="1"
					class="
						w-260
						h-260
						rounded-full
						flex-shrink-0 flex-grow-0
						>=605:ml-auto >=605:order-1
					"
					image-class-names="rounded-full overflow-hidden"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import UmbracoImageExt from '~/components/shared/UmbracoImageExt';
import LongReadTarget from '~/citi-baseline/components/LongRead/LongReadTarget';
import SvgIconPhone from '~/assets/svgs/icon-phone.svg?inline';
import SvgIconMobile from '~/assets/svgs/icon-mobile.svg?inline';
import SvgIconEmail from '~/assets/svgs/icon-email.svg?inline';

export default {
	name: 'BlockListContactPersonCustom',

	components: {
		UmbracoImageExt,
		LongReadTarget,
		SvgIconPhone,
		SvgIconMobile,
		SvgIconEmail,
	},

	inheritAttrs: false,

	props: {
		title: String,
		includeInToc: Boolean,
		contactpersons: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
